var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"dense":"","fixed-header":"","headers":_vm.headers,"items":_vm.items,"item-key":"_id","hide-default-footer":"","items-per-page":-1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }